<template>
    <div class="vue timparty-reward-detail reward-detail" v-if="current_reward">

      <LoaderOverlay v-if="loading"/>
      <div class="tp-featured reward-container">

        <!-- HEADER / BEGIN -->
        <div class="reward-header">
          <div class="row row-eq-height">
            <div class="col-sm-6  text-right">
              <div class="reward-info half-container-sm text-left p-4">

                <div>
                  <h1 class="tp-title reward-title text-white" v-html="current_reward.title"></h1>
                  <div v-if="reward_sections.length > 0" class="tp-description iw-description text-white d-none d-md-block mt-4" v-html="current_reward.description.base"></div>
                </div>

              </div>
            </div>
            <div class="col-md-6 iw-carousel-container reward-carousel-container p-0">

                <!-- FEATURED CAROUSEL - BEGIN -->
                <featured-carousel :images='sliderImages'></featured-carousel>
                <!-- FEATURED CAROUSEL - END -->

            </div>
          </div>
        </div>
        <!-- HEADER / END -->


        <!-- ------------------------------------ -->



        <!-- ACTIONS / BEGIN  -->

          <div class="reward-actions-bar-container" v-if="current_state">
            <div class="container p-0">
              <div :class="'reward-actions-bar ' + (isSpecial ? 'special' : '')">
                <div v-if="isSpecial" class="reward-special-tooltip d-flex justify-content-center align-items-center">{{ current_reward.sector }}</div>

                <!-- STATE : START / BEGIN -->
                <div v-if="current_state == 'start'">


                  <div class="row no-gutters">
                    <div class="col-sm-3  order-1 order-md-0 p-3" >
                      <div class="d-flex align-items-start ">
                        <div class="p-3" v-html="current_reward.commercialName"></div>
                      </div>
                    </div>
                    <div class="col-sm-3 order-0 order-md-1 d-flex align-items-center justify-content-center p-3" >
                      <countdown v-if="current_reward.endDate" class="reward-countdown" :ts-end="current_reward.endDate" heading="L'OFFERTA SCADE TRA"></countdown>
                    </div>
                    <div class="col-sm-6 order-2 d-flex align-items-top">
                      <div class="w-100">
                        <div class="reward-retrieve-container">

                          <div class="row">
                            <div
                              class="col-sm-8 form-timparty"
                              v-if="typeof current_reward.lockedMessageLabel === 'undefined'
                                || !current_reward.lockedMessageLabel.length"
                            >
                              <div class="form-group mb-0" v-if="emailRequired && !current_reward.locked">
                                <label>{{ __('Email del destinatario') }}</label>
                                <input type="text" class="form-control" v-model="user_email">
                              </div>
                            </div>
                            <div
                              class="col-sm-4"
                              v-if="typeof current_reward.lockedMessageLabel === 'undefined'
                                || !current_reward.lockedMessageLabel.length"
                            >
                              <button :class="'btn btn-lg btn-block reward-btn-retrieve ' + (isSpecial ? 'btn-red' : 'btn-primary' )" :disabled="current_reward.locked" @click.prevent="showRetrieveModal">{{ __('RICHIEDI') }}</button>
                            </div>
                            <div v-else>
                              <div class="col-sm-12">
                                <div class="pt-3">{{ current_reward.lockedMessageLabel[0] }}</div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- STATE : START / END -->




                <!-- STATE : RETRIEVED / BEGIN -->
                <div v-else-if="current_state == 'retrieved' || current_state == 'rating'" class="">
                   <div class="row no-gutters">

                    <div class="col-sm-4 p-3" >
                      <div class=" ">
                        <div>{{ __('Hai già richiesto il vantaggio') }}</div>
                        <div v-if="current_voucher" class="voucher-code">
                          <span class="label">{{ __('PIN - NEGOZI TIM') }}</span> <span class="value">{{ current_voucher }}</span></div>
                      </div>
                    </div>
                    <div class="col-sm-4 d-flex align-items-center justify-content-center p-3" v-if="enableRating">
                      <p class="m-0" v-if="current_rating > 0">La tua valutazione del vantaggio:</p>
                      <p class="m-0" v-else>Il vantaggio che hai scelto ti è piaciuto? <br> Esprimi la tua opinione con le stelline.</p>
                    </div>
                    <div class="col-sm-4 d-flex align-items-center" v-if="enableRating">
                      <div class="d-inline-block">
                        <vue-stars v-model="tmp_rating"
                                    activeColor="#02D0D2"
                                    inactiveColor="#FFFFFF"
                                    shadowColor="#02D0D2"
                                    :readonly="current_rating > 0"

                                    >
                        </vue-stars>
                      </div>
                      <button class="btn btn-primary btn-lg" v-if="!current_rating" @click.prevent="handleRating">{{ __('VOTA') }}</button>
                    </div>
                  </div>
                </div>
                <!-- STATE : RETRIEVED  / END -->



              </div>
            </div>
          </div>
        </div>

        <!-- ACTIONS / END  -->

        <div class="bg-warning p-4" v-if="environment == 'dev'">
          <div class="container">
            <h5>Development tools</h5>

            <div class="form-inline m-3">
              <select v-model="current_state" class="form-control form-control-sm">
                <option value="">---</option>
                <option value="start">start</option>
                <option value="rating">rating</option>
                <option value="retrieved">retrieved</option>

              </select>
            </div>


          </div>
        </div>



        <!-- SECTIONS / BEGIN -->
        <div class="reward-sections" v-if="reward_sections.length > 0">
          <div class="reward-section" v-for="(section, idx) in reward_sections" v-bind:key="idx">


            <cards-image-slider v-if="section.template == 'SLIDING_CARDS'" :data="section.data" :image="getCardsImageSliderImage(section.index)"></cards-image-slider>
            <cards-steps-slider v-else-if="section.template == 'STEPS'" :data="section.data"></cards-steps-slider>
            <cards-specifications v-else-if="section.template == 'TECNICAL'" :data="section.data"></cards-specifications>
          </div>
        </div>
        <!-- SECTIONS / END -->




        <!-- MODAL RETRIEVAL / START -->
        <basic-modal :modal-id="modal_id" modal-class="modal-xl" class="modal-acceptance" :show="modal.show" v-on:modalClose="modal.show = false">


          <div v-if="!modal.error">

            <div v-if="modal.state == 'confirm'">
              <div class="modal-body text-center pb-5">
                <div class=" p-2 reward-gift-icon">
                  <IconGiftClosed/>
                </div>
                <div v-if="current_reward.template != 'TIM_EMAIL'">
                  <h3 class="font-weight-bold ">{{ __('Il tuo vantaggio si avvicina... ci siamo quasi!') }}</h3>

                  <div class="mt-4">

                    <p>
                    {{ __('Stai per richiedere ') }} <strong v-html="current_reward.title"></strong><br>
                      <span v-if="emailRequired">
                        {{ __('Ti verrà inviato al tuo indirizzo di posta elettronica ') }}  <strong> {{ user_email }} </strong>
                      </span>
                      <span v-else>
                        {{ __('Verrà attivato sulla tua linea telefonica ') }}  <strong> {{ user.loyalty_line }} </strong>
                      </span>

                    </p>

                    <div class="mt-4">
                      <div class="row no-gutters">
                        <div class="col-6 text-right px-1"><button class="btn btn-outline-primary btn-lg" @click="modal.show = false">{{ __('ANNULLA') }}</button></div>
                        <div class="col-6 text-left px-1"><button class="btn btn-primary btn-lg" @click="retrieveReward">{{ __('CONFERMA') }}</button></div>
                      </div>
                    </div>

                  </div>
                </div>
                <div v-else>
                  <h3 class="font-weight-bold ">{{ __('Abilita la tua linea per l’acquisto del tuo prodotto a rate') }}</h3>

                  <div class="mt-4">

                    <p v-html="'Stai per abilitare la tua linea <strong>' + user.loyalty_line + '</strong> per l’acquisto del tuo prodotto a rate. Entro 48 ore riceverai una email con tutte le istruzioni per usufruire di questa imperdibile offerta!'">
                    </p>

                    <div class="mt-4">
                      <div class="row no-gutters">
                        <div class="col-6 text-right px-1"><button class="btn btn-outline-primary btn-lg" @click="modal.show = false">{{ __('ANNULLA') }}</button></div>
                        <div class="col-6 text-left px-1"><button class="btn btn-primary btn-lg" @click="retrieveReward">{{ __('CONFERMA') }}</button></div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="modal.state == 'retrieve_result'">
              <div class="modal-body text-center">
                <div class=" p-2 reward-gift-icon">
                  <IconGiftOpen/>
                </div>
                <h3 class="font-weight-bold mt-4">{{ __('Congratulazioni!') }}</h3>

                <div class="mt-4">

                  <div v-if="current_reward.template == 'TIM_EMAIL'">
                    <p class="mx-4" v-html="'Stiamo abilitando la tua linea ' + user.loyalty_line + ' per l’acquisto del prodotto a rate. Entro 48 ore riceverai una mail contenente tutte le informazioni utili ad usufruire di questa imperdibile offerta!'">

                    </p>
                  </div>
                  <div v-else-if="emailRequired">
                    <p class="mx-4">
                      {{ __('Stiamo per inviare il vantaggio da te richiesto ') }} <strong v-html="current_reward.title"></strong> {{ __(' al tuo indirizzo di posta ') }} <strong> {{ user_email }} </strong><br>
                      {{ __('A breve riceverai un\'e-mail con la conferma della tua richiesta e informazioni utili per l\'utilizzo del tuo vantaggio.') }}
                    </p>
                    <p>
                      {{ __('Nell\'e-mail troverai tutte le informazioni necessarie per utilizzare subito il tuo vantaggio.') }}
                    </p>
                  </div>
                  <div v-else>
                    <p class="mx-4">
                    {{ __('Stiamo per attivare il vantaggio da te richiesto ') }} <strong v-html="current_reward.title"></strong> {{ __(' sulla tua linea telefonica ') }} <strong> {{ user.loyalty_line }} </strong><br>
                    </p>

                  </div>

                  <div class="mb-5">
                    <button class="btn btn-primary btn-lg" @click="modal.show = false">{{ __('Chiudi') }}</button>
                  </div>

                </div>

              </div>
              <div class="bg-dark p-5" v-if="user.flg_privacy_mail != '1'">
                <NewsletterBox />
              </div>
            </div>


            <div v-else-if="modal.state == 'rating_result'">
              <div class="modal-body text-center">

                <h3 class="font-weight-bold mt-4">{{ __('Grazie') }}</h3>

                <div class="mt-4">
                  <p class="mx-4">
                    {{ __('Ti ringraziamo per averci comunicato il tuo giudizio.') }}<br>
                    {{ __('La tua opinione per noi è importante e ci aiuta a migliorare i nostri prodotti e servizi costantemente.') }}<br>
                    {{ __('Solo per te.') }}
                  </p>

                  <div class="mb-5">
                    <a class="btn btn-primary btn-lg" href="/vantaggi">{{ __('SCOPRI ALTRI VANTAGGI') }}</a>
                  </div>

                </div>

              </div>
            </div>

          </div>
          <div v-else class="card-body text-center">
              <IconAlert/>

              <h5 class="mt-4 font-weight-bold">{{ modal.error.title }}</h5>
              <div class="mt-3" v-html="modal.error.content"></div>

          </div>
        </basic-modal>
        <!-- MODAL RETRIEVAL / END -->





        <!-- MODAL ERROR / BEGIN -->
        <ErrorModal :error="error" v-on:modalClose="closeErrorPopup"/>
        <!-- MODAL ERROR / END -->

      <div v-if="reward_sections.length == 0">
        <div class="reward-description  p-5" v-if="current_reward.description">
          <div class="container">
              <div class="text-black" v-html="current_reward.description.simple"></div>
          </div>
        </div>

        <div class="reward-description  bg-light p-5" v-if="current_reward.description">
          <div class="container">
              <div class="text-black" v-html="current_reward.description.base"></div>
          </div>
        </div>
      </div>



    </div>
</template>

<script>

    /* eslint-disable */



    import _ from 'lodash';
    import TimPartyMixin from '../mixins/TimPartyMixin';
    import BasicModal from './BasicModal.vue'
    import ErrorModal from './ErrorModal.vue'
    import Countdown from './Countdown.vue'
    import LoaderOverlay from './LoaderOverlay.vue'
    import FeaturedCarousel from './FeaturedCarousel.vue'
    import NewsletterBox from './NewsletterBox.vue'

    import CardsStepsSlider from './CardsStepsSlider.vue'
    import CardsImageSlider from './CardsImageSlider.vue'
    import CardsSpecifications from './CardsSpecifications.vue'

    import ArrowLeft from '../assets/images/arrow-white-left.svg';
    import ArrowRight from '../assets/images/arrow-white-right.svg';
    import IconGiftOpen from '../assets/images/icon-gift-open.svg';
    import IconGiftClosed from '../assets/images/icon-gift-closed.svg';

    import { VueStars } from "vue-stars"


    import $ from 'jquery';

    export default {
      name: 'RewardsDetail',
      mixins: [ TimPartyMixin ],
      components: { Countdown,
                    LoaderOverlay,
                    BasicModal,
                    ErrorModal,

                    ArrowLeft,
                    ArrowRight,
                    IconGiftOpen,
                    IconGiftClosed,

                    VueStars,
                    FeaturedCarousel,
                    NewsletterBox,

                    CardsStepsSlider,
                    CardsImageSlider,
                    CardsSpecifications,

                    },
      props: {
        accessToken: {
          type: String,
          // required: true
        },
        apiUrl: {
          type: String,
          required: true
        },
        rewardId: {
          type: Number,
          required: true
        },
        enableRating: {
          type: Boolean,
          required: false,
          default: true,
        },


      },

      data: function(){

        return {
          loading: false,
          current_state: null,

          current_reward: {},
          current_voucher: null,
          current_rating: null,
          tmp_rating: null,

          modal_id: 'modal-reward-detail',
          show_modal: false,


          modal: {
            id: 'modal-reward-detail',
            show: false,
            class_name: 'modal-lg',
            error: null,
            state: null,
          },

          user_email: '',

          reward_sections: [],




          acceptances: {
            regulation: false,
            privacy: false,
          }
        };
      },
      mounted: function(){
        var self = this;

        this.setApiUrl(this.apiUrl);


        this.getReward( function(){

          if( !self.current_reward.redimible ){
            self.current_state = 'retrieved';
          }


          if( self.current_reward.stars > 0 ){
            self.current_rating = self.current_reward.stars;
            self.tmp_rating = self.current_reward.stars;
          }

          if( self.user && self.emailRequired){
            self.user_email = self.user.email;
          }

          var aa_payload = {
            page: {
              category: {
                primaryCategory: 'Vantaggi',
              },
              pageInfo:{
                pageName: self.current_reward.title,
              },
            }
          };
          self.aaEvent('page', aa_payload);

          console.log(self.current_reward);
        });



      },

      methods: {

        showRetrieveModal: function(){

          this.user_email = this.user_email.trim();

          if( this.emailRequired && !this.checkEmail( this.user_email ) ){

            console.log('ERRORE MAIL');
            this.error = {
              title: this.__('Email non valida'),
              content: this.__('Si prega di verificarla e riprovare'),
            };
            return;
          }

          this.modal.show = true;
          this.modal.state = 'confirm';
        },

        showShareModal: function(){
          this.show_modal = true;
          this.modal.state = 'share';
        },


        getReward: function( callback ){

          if(!this.rewardId)
            return false;


          var self = this;

          var payload = {
            action: 'getReward',
            access_token: this.access_token,
            reward_id: this.rewardId,

          };


          this.loading = true;

          this.callApiGet( payload, function( response){

            self.loading = false;
            self.current_reward = response.data;
            self.current_state = 'start';

            if (self.current_reward.errorCode && self.current_reward.errorCode === "0001") {
              self.error = {
                title: null,
                content: self.__('Impossibile visualizzare il vantaggio'),
              };
            }

            if(self.current_reward.sections != undefined && self.current_reward.sections.length > 0){
              var tmp_sections = [];
              var previous_template = null;
              var sections_index = {};

              for(var i in self.current_reward.sections){
                var section = self.current_reward.sections[i];

                if(sections_index[section.template] == undefined ){
                  sections_index[section.template];
                }
                else{
                  sections_index[section.template]++;
                }


                if(section.template == 'TECNICAL'){

                    if(sections_index[section.template] == undefined ){
                      sections_index[section.template] = 0;
                    }
                    else{
                      sections_index[section.template]++;
                    }

                    if(previous_template != 'TECNICAL'){
                      tmp_sections.push({ template: section.template, index:  sections_index[section.template] ,data: [ section ] });
                    }
                    else{
                      tmp_sections[ tmp_sections.length - 1 ].data.push( section );
                    }
                }
                else{

                  if(sections_index[section.template] == undefined ){
                    sections_index[section.template] = 0;
                  }
                  else{
                    sections_index[section.template]++;
                  }

                  tmp_sections.push({ template: section.template, index:  sections_index[section.template], data: section});
                }

                previous_template = section.template;

              }


              self.reward_sections = tmp_sections;
            }

            if(callback)
              callback();

          } );
        },

       retrieveReward: function(){
          var self = this;

          self.modal.show = false;

          var payload = {
            action: 'retrieveReward',
            access_token: this.access_token,
            reward: this.current_reward,
            email: this.user_email,
          };

          self.loading = true;
          this.callApi( payload, function(response){
            self.loading = false;

            if(response.success) {
              self.current_voucher = response.voucherCode;

              self.current_state = 'rating';
              self.modal.show = true;
              self.modal.state = 'retrieve_result';

              self.gtmEvent({event: 'redeemVantaggi', eventCategory: 'Redeem Vantaggi', eventAction: 'Success’,', eventLabel: self.current_reward.title });

            }
            else{
              self.error = {
                title: 'Si è verificato un errore nella richiesta',
                content: response.detail != undefined ? response.detail :'',
              };
            }

          } );
        },


        handleRating: function(){
          var self = this;

          self.modal.show = false;

          var payload = {
            action: 'rateReward',
            access_token: this.access_token,
            reward: this.current_reward,
            rating: this.tmp_rating,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;


            if( response.success ){//

              self.current_rating = self.tmp_rating;
              self.current_voucher = response.voucherCode;

              self.current_state = 'rating';
              self.modal.show = true;
              self.modal.state = 'rating_result';

              self.gtmEvent({event: 'redeemVantaggi', eventCategory: 'Redeem Vantaggi', eventAction: 'Success’,', eventLabel: self.current_reward.title });

            }
            else{
              self.error = {
                title: 'Si è verificato un errore nella richiesta',
                content: response.detail != undefined ? response.detail :'',
              };
            }

          } );
        },

        getCardsImageSliderImage: function(index){
          if( this.current_reward.extra != undefined && this.current_reward.extra.images != undefined && this.current_reward.extra.images['cards-image-slider'] != undefined && this.current_reward.extra.images['cards-image-slider'][index] != undefined )
            return this.current_reward.extra.images['cards-image-slider'][index];
          else
            return null;

        },

        closeErrorPopup: function() {
          var self = this;

          self.error = null;
          if (self.current_reward.errorCode && self.current_reward.errorCode === "0001") {
            document.location.href = "/";
          }
        }



      },
      computed: {
        isSpecial: function(){
          return this.current_reward.sector == this.user.sector_special_name;
        },

        emailRequired: function(){
          return this.current_reward.template != 'TIM';
        },

        sliderImages: function(){

          if( this.current_reward.extra != undefined && this.current_reward.extra.images.slider != undefined )
            return this.current_reward.extra.images.slider;
          else if( this.current_reward.extra != undefined && this.current_reward.extra.images.featured != undefined )
            return this.current_reward.extra.images.featured;
          else return [];

        },


      },
      watch:{

      }
    }
  </script>


